export default {
      id: "AUD-usage",
      viewBox: "0 0 22.6 16.2",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#AUD",
      toString: function () {
        return this.url;
      }
    }